<template>
  <div class="cpc-detail-page">
    <div class="inner">
      <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
    </breadcrumbs>


      <div class="tabs-wrap">
        <artmisads-segmented-tabs v-model="activeTab" :items="tabItems" />
      </div>

      <div class="info-card">
        <component :is="currentTabComponent" :detail="detail" :id="id"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue"
import { useI18n } from "vue-i18n"
import { useRoute, useRouter } from "vue-router"
import CampaignInfoTab from "./components/CampaignInfoTab.vue"
import ProductsTab from "./components/ProductsTab.vue"
import PublishersTab from "./components/PublishersTab.vue"
import breadcrumbs from "~/pages/seller/breadcrumbs.vue"

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const activeTab = ref("0")
const id = route.params.id

const breadcrumbsData = computed(() => ({
  title: t("seller.cpcDetail.breadcrumbTitle"),
  color: "#26AADC",
  hasTitleIcon: false,
  links: [
    {
      name: t("seller.common.home"),
      path: "/seller/dashboard",
    },
    {
      name: t("seller.cpcIndex.breadcrumbCpc"),
      path: "/seller/cpc",
    },
  ],
}))

const tabItems = computed(() => [
  { key: "0", label: t("seller.cpcDetail.tabCampaignInfo") },
  { key: "1", label: t("seller.cpcDetail.tabProducts") },
  { key: "2", label: t("seller.cpcDetail.tabPublishers") },
])

const detailsMap = {
  1: {
    id: 1,
    title: "Test CPC Campaign xxxxx..",
    cpc: { att: "$ 0.50", ass: "$ 0.60" },
    budget: { total: "$ 1000.00", remain: "$ 200.00" },
    cap: { total: "$ 100.00", daily: "$ 200.00" },
    startDate: "2026.04.01",
    endDate: "2026.04.31",
    linkType: "Attribution , Associate",
    status: "Active",
  },
  2: {
    id: 2,
    title: "Test CPC Campaign 2",
    cpc: { att: "$ 0.50", ass: "$ 0.50" },
    budget: { total: "$ 100.00", remain: "$ 0.00" },
    cap: { total: "$ 100.00", daily: "$ 50.00" },
    startDate: "2026.04.01",
    endDate: "2026.04.31",
    linkType: "Attribution",
    status: "Finished",
  },
  3: {
    id: 3,
    title: "Test CPC Campaign incoming",
    cpc: { att: "$ 0.60", ass: "$ 0.60" },
    budget: { total: "$ 120.00", remain: "$ 120.00" },
    cap: { total: "$ 120.00", daily: "$ 50.00" },
    startDate: "2026.05.01",
    endDate: "2026.05.31",
    linkType: "Associate",
    status: "Incoming",
  },
}

const detail = computed(() => {
  const id = Number(route.params.id)
  return detailsMap[id] || detailsMap[1]
})

const currentTabComponent = computed(() => {
  if (activeTab.value === "0") return CampaignInfoTab
  if (activeTab.value === "1") return ProductsTab
  return PublishersTab
})

const goCpcList = () => {
  router.push("/seller/cpc")
}
</script>

<style scoped lang="less">
.cpc-detail-page {
  padding: 16px;
  padding-top: 0;
}

.inner {
  // background: #f7f7fb;
  border-radius: 8px;
  padding: 12px;
  min-height: 400px;
}

.breadcrumb-line {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 8px;
}

.crumb {
  cursor: pointer;
}

.crumb.current {
  color: #111827;
  cursor: default;
}

.divider {
  margin: 0 6px;
}

.title {
  margin: 0 0 12px;
  color: #374151;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 700;
}

.tabs-wrap {
  max-width: 560px;
  margin-bottom: 12px;
}

.info-card {
  background: #fff;
  border-radius: 6px;
  padding: 14px 16px;
}
</style>
